import { createElement } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import {
	CONFIG_MODE,
	CONFIG_SHA,
	CONFIG_VERSION,
	CONFIG_ENVIRONMENT,
	CONFIG_SENTRY_DEBUG,
	CONFIG_SENTRY_DSN,
} from "./config";
import { Sentry_attach } from "./sentry";
import {
	Session_fromStorage,
	Session_fromUrl,
	Session_toStorage,
} from "./session";
import { logger } from "./shared/logger";
import { tags, tags_fromConfig, tags_fromSession } from "./tags";
import { Transport_attach } from "./transport";

console.groupCollapsed(`Zeller SDK (${CONFIG_SHA ?? "${CONFIG_SHA}"})`);
console.table({
	CONFIG_MODE,
	CONFIG_SHA,
	CONFIG_VERSION,
	CONFIG_ENVIRONMENT,
	CONFIG_SENTRY_DEBUG,
	CONFIG_SENTRY_DSN,
});
console.groupEnd();

Sentry_attach();

tags(tags_fromConfig(), { global: true });

void (() => {
	const session_fromUrl = Session_fromUrl();
	if (session_fromUrl) {
		const properties = tags_fromSession(session_fromUrl);
		logger.debug("tags: session from url", properties);
		tags(properties, { global: true });
		Session_toStorage(session_fromUrl);
		return;
	}

	const session_fromStorage = Session_fromStorage();
	if (session_fromStorage) {
		const properties = tags_fromSession(session_fromStorage);
		logger.debug("tags: session from storage", properties);
		tags(properties, { global: true });
		return;
	}

	// No session: tag vendor "unknown" so it still shows in vendor breakdowns.
	tags(tags_fromSession({}), { global: true });
	logger.warn("session: unknown");
})();

Transport_attach();
createRoot(document.getElementById("root")!).render(createElement(App, {}));
